module.exports = __webpack_public_path__ + "static/img/agb_6.ef83eb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/agb_6.png
// module id = 1256
// module chunks = 1